@if (ComplianceSetting) {
  <div class="compliance-review-body">
    <!-- Insurance agents section -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card>
          <div class="ins-section-head">
            <h3 class="mb-0">Insurance agents</h3>
            <button
              type="button"
              class="btn btn-outline btn-sm"
              (click)="addAgent()"
            >
              <i class="bi bi-plus-lg me-1"></i>
              Add agent
            </button>
          </div>

          @if ((InsuranceAgentsMappedById | keyvalue).length === 0) {
            <p class="text-secondary mb-0">No insurance agents added yet.</p>
          }

          @if ((InsuranceAgentsMappedById | keyvalue).length > 0) {
            <div class="row g-3">
              @for (
                InsuranceAgentObject of InsuranceAgentsMappedById | keyvalue;
                track InsuranceAgentObject
              ) {
                <div class="col-md-6">
                  <div class="ins-agent-card">
                    <header class="ins-agent-card__head">
                      <div class="ins-agent-card__title">
                        <h4 class="ins-agent-card__agency">
                          {{ InsuranceAgentObject.value.agencyName }}
                        </h4>
                        <p class="ins-agent-card__agent">
                          {{ InsuranceAgentObject.value.firstName }}
                          {{ InsuranceAgentObject.value.lastName }}
                        </p>
                      </div>
                      @if (
                        getInsurancePolicyTypesFromAgent(
                          InsuranceAgentObject.value
                        )
                      ) {
                        <div class="ins-agent-card__policies">
                          @for (
                            policy of getInsurancePolicyTypesFromAgent(
                              InsuranceAgentObject.value
                            ).split(', ');
                            track policy
                          ) {
                            <span class="ins-agent-card__policy">
                              {{ policy }}
                            </span>
                          }
                        </div>
                      }
                    </header>

                    <dl class="ins-agent-card__details">
                      @if (InsuranceAgentObject.value.email) {
                        <div class="ins-agent-card__row">
                          <dt>Email</dt>
                          <dd>
                            <app-email-container
                              [email]="InsuranceAgentObject.value.email"
                            ></app-email-container>
                          </dd>
                        </div>
                      }
                      <div class="ins-agent-card__row">
                        <dt>Phone</dt>
                        <dd>{{ InsuranceAgentObject.value.phone1 }}</dd>
                      </div>
                    </dl>

                    <div class="ins-agent-card__actions">
                      <button
                        type="button"
                        class="ins-agent-card__icon-btn"
                        title="Archive agent"
                        aria-label="Archive agent"
                        (click)="archiveAgent(InsuranceAgentObject.value)"
                      >
                        <i class="bi bi-archive"></i>
                      </button>
                      <div class="ins-agent-card__action-cluster">
                        <button
                          type="button"
                          class="btn btn-outline btn-sm ins-agent-card__btn"
                          (click)="createTicket(InsuranceAgentObject.value)"
                        >
                          Create ticket
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline btn-sm ins-agent-card__btn"
                          (click)="editAgent(InsuranceAgentObject.value)"
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary btn-sm ins-agent-card__btn"
                          (click)="addCOI(InsuranceAgentObject.value)"
                        >
                          Add COI
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </app-display-card>
      </div>
    </div>

    <!-- COIs grid -->
    <div class="row mb-3">
      <div class="col">
        <app-display-card>
          <div class="ins-section-head">
            <h3 class="mb-0">Certificates of insurance</h3>
            <form
              [formGroup]="COIGridFormGroup"
              class="ins-section-head__filter"
            >
              <div class="check-group mt-0">
                <input
                  id="coiShowArchived"
                  type="checkbox"
                  class="form-check-input"
                  formControlName="showArchived"
                />
                <label for="coiShowArchived" class="form-check-label mt-0">
                  Show archived
                </label>
              </div>
            </form>
          </div>
          <div class="ins-grid">
            <app-insurance-certificates-grid
              [gridName]="'AdminInsuranceCertificates'"
              [suppliedQueryData]="SuppliedCOIGridQuery"
              [ColumnIdToColumnActions]="ColumnIdToColumnActions"
              [getCalculatedColumnActions]="getCalculatedColumnActions"
              [TooltipMap]="COITooltipMap"
              (actionEvent)="coiGridAction($event)"
              [(reloadGridData)]="reloadCOIGrid"
            ></app-insurance-certificates-grid>
          </div>
        </app-display-card>
      </div>
    </div>

    <!-- Findings + summary panels -->
    @if (isInsuranceCertificateFindingResults()) {
      <div class="row mb-3">
        <div class="col">
          <app-insurance-certificate-finding-and-results
            [InsuranceCertificateFindingResults]="
              InsuranceCertificateFindingResults
            "
            [InsuranceCertificatesMappedById]="InsuranceCertificatesMappedById"
          ></app-insurance-certificate-finding-and-results>
        </div>
      </div>
    }
    <div class="row">
      <div class="col g-0">
        @if (ComplianceResults) {
          <app-insurance-info-display-card
            [Vendor]="Vendor"
            [Company]="Company"
            [CompanyVendor]="CompanyVendor"
            [ComplianceResults]="ComplianceResults"
          ></app-insurance-info-display-card>
        }
      </div>
    </div>
  </div>
}
